import { render, staticRenderFns } from "./goodsActivity.vue?vue&type=template&id=2566d68f&scoped=true"
import script from "./goodsActivity.vue?vue&type=script&lang=js"
export * from "./goodsActivity.vue?vue&type=script&lang=js"
import style0 from "./goodsActivity.vue?vue&type=style&index=0&id=2566d68f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566d68f",
  null
  
)

export default component.exports